module.exports = __webpack_public_path__ + "static/slider_2-c7cf0338e2ab1be31d0bb7e0ba5a5f41.jpg";